import React from 'react'

import { IconProps } from '../Types'

export const IdeaFill = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="IdeaFill"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path d="m13.68,22h-3.34c-.41,0-.79-.16-1.08-.45-.15-.14-.26-.31-.35-.5s-.13-.39-.13-.59v-1.94c-.86-.55-1.57-1.32-2.05-2.22-.49-.9-.74-1.92-.73-2.95s.27-2.04.77-2.94c.5-.9,1.22-1.65,2.08-2.19.92-.56,1.96-.87,3.04-.9,1.07-.03,2.13.24,3.07.78.94.53,1.72,1.31,2.26,2.24.55.93.84,2,.83,3.08,0,1.01-.27,2-.75,2.88-.49.88-1.18,1.63-2.03,2.17v1.95c0,.42-.18.82-.48,1.12-.15.15-.32.26-.52.34-.19.08-.4.12-.61.11Zm7.32-11.42h-2.15c-.27,0-.52-.11-.71-.3s-.29-.45-.29-.71.11-.53.29-.71c.19-.19.44-.3.71-.3h2.15c.27,0,.52.11.71.3.19.19.29.45.29.71s-.11.53-.29.71-.44.3-.71.3Zm-15.85,0h-2.15c-.27,0-.52-.11-.71-.3-.19-.19-.29-.45-.29-.71s.11-.53.29-.71c.19-.19.44-.3.71-.3h2.15c.27,0,.52.11.71.3.19.19.29.45.29.71s-.11.53-.29.71c-.19.19-.44.3-.71.3Zm2.64-2.94c-.14,0-.28-.02-.4-.08-.13-.05-.24-.13-.34-.23l-1.52-1.55c-.09-.09-.17-.21-.22-.33-.05-.12-.07-.26-.07-.39,0-.13.03-.26.08-.39.05-.12.13-.23.22-.33.09-.09.2-.17.33-.22s.25-.08.38-.07c.13,0,.26.03.38.08.12.05.23.13.32.22l1.52,1.55c.12.14.2.32.23.51.03.19,0,.38-.07.56-.07.18-.19.33-.35.44-.15.11-.34.17-.53.18l.03.05Zm8.43,0c-.27,0-.52-.11-.71-.29-.09-.09-.17-.21-.22-.33-.05-.12-.08-.25-.08-.39s.03-.26.08-.39c.05-.12.12-.23.22-.33l1.52-1.55c.09-.1.2-.18.32-.24.12-.06.26-.09.39-.09.14,0,.27.02.4.07s.24.13.34.22c.1.1.17.21.22.34.05.13.08.26.07.4,0,.14-.03.27-.09.4-.06.12-.14.24-.24.33l-1.53,1.54c-.09.1-.2.17-.32.23-.12.05-.25.08-.38.08Zm-4.22-1.45c-.27,0-.52-.11-.71-.3-.19-.19-.29-.45-.29-.71v-2.17c0-.27.11-.53.29-.71s.44-.3.71-.3.52.11.71.3c.19.19.29.45.29.71v2.17c0,.13-.03.27-.08.39-.05.12-.13.23-.22.33-.09.09-.21.17-.33.22-.12.05-.25.08-.39.07h0Z"/>',
    }}
  />
)

IdeaFill.displayName = 'IdeaFill'

export const tags = ['IdeaFill', '']
